import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap'
import 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import DKToast from 'vue-dk-toast'
import Dropdown from 'vue-simple-search-dropdown'
import titleMixin from '../titleMixin'
import VueCookies from 'vue3-cookies'
import VueMask from 'vue-jquery-mask'
import loader from './lib/loader'

// Create App
createApp(App)
  .use(store)
  .use(router)
  .use(DKToast)
  .use(Dropdown)
  .use(VueCookies)
  .use(loader)
  .mixin(titleMixin)
  .use(VueMask)
  .mount('#app')
